import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'loyaltic-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    standalone: false
})
export class AdminComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
    // Legacy ADAL-based admin gate removed; redirect to home for now.
    this.router.navigate(['/']);
  }

}
